import { useFormState } from 'react-hook-form'
import {
	Empty,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
	EmptyTitle,
} from '@cocoonspace/ui/components/empty'
import { cn } from '@cocoonspace/ui/lib/utils'
import { Trans, useLingui } from '@lingui/react/macro'
import { BuildingIcon } from 'lucide-react'

import type { EditEventTypeFormData } from '../event-type-form'

export const LocationEmpty = () => {
	const { t } = useLingui()

	const { errors } = useFormState<EditEventTypeFormData>()

	return (
		<Empty
			className={cn('!py-2', { 'text-destructive': errors.location?.message })}
		>
			<EmptyHeader>
				<EmptyMedia
					variant='icon'
					className='bg-secondary'
				>
					<BuildingIcon />
				</EmptyMedia>

				<EmptyTitle>{t`Aucune localisation`}</EmptyTitle>

				<EmptyDescription>
					<Trans>
						Choisissez un lieu
						<br />
						ou un service de vidéo-conférence
					</Trans>
				</EmptyDescription>
			</EmptyHeader>
		</Empty>
	)
}
